import { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { apiError } from "../lib/auth";
import { useFlash } from "../lib/flash";

function MxStatus({ mx }) {
  if (!mx) return <span className="muted" data-testid="mail-mx-status">Tjekker…</span>;
  return mx.ok ? (
    <span className="mx-ok" data-testid="mail-mx-status">Kan modtage mail: <b>ja</b> <span className="muted">({mx.hosts.join(", ")})</span></span>
  ) : (
    <span className="mx-bad" data-testid="mail-mx-status">
      Kan modtage mail: <b>nej</b> – {mx.domain || "domænet"} har ingen MX-post, så svar og supportmails til adressen vil blive afvist.
    </span>
  );
}

export default function MailSettings() {
  const flash = useFlash();
  const [d, setD] = useState(null);
  const [v, setV] = useState("");
  const [mx, setMx] = useState(null);
  const [err, setErr] = useState("");
  const timer = useRef();
  useEffect(() => {
    api.get("/owner/mail-settings").then((r) => {
      setD(r.data);
      setV(r.data.support_inbox);
      setMx(r.data.mx);
    });
  }, []);
  const change = (e) => {
    const val = e.target.value;
    setV(val);
    setMx(null);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => api.get("/owner/mail-mx", { params: { email: val } }).then((r) => setMx(r.data)), 500);
  };
  if (!d) return null;
  const save = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const r = await api.put("/owner/mail-settings", { support_inbox: v });
      flash(r.data.flash, r.data.mx.ok ? undefined : "warn");
      setMx(r.data.mx);
    } catch (ex) {
      if (ex.response?.data?.errors) setErr(ex.response.data.errors.support_inbox);
      else flash(apiError(ex.response?.data?.detail) || ex.message, "error");
    }
  };
  return (
    <form className="bf-grid ss-grid" onSubmit={save} noValidate data-testid="mail-settings" style={{ marginTop: 16 }}>
      <div className="field" style={{ gridColumn: "1 / -1" }}>
        <label htmlFor="ms-inbox">Svar-adresse og supportindbakke</label>
        <input id="ms-inbox" type="email" value={v} onChange={change} aria-invalid={!!err} data-testid="mail-support-inbox" />
        {err && <div className="bf-err">{err}</div>}
        <div className="hint">
          Bruges som svar-adresse på alle mails fra JaTak Pro (fakturaer, kvitteringer, velkomst, nulstilling og support), og supporthenvendelser sendes hertil.
          Kunderne ser stadig {d.public} som kontaktadresse.
        </div>
        <div style={{ marginTop: 6, fontSize: 14 }}><MxStatus mx={mx} /></div>
      </div>
      <div className="bf-actions" style={{ gridColumn: "1 / -1" }}>
        <button className="btn" data-testid="mail-settings-save">Gem svar-adresse</button>
      </div>
    </form>
  );
}
